/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { useIntl } from 'react-intl'
import { KTIcon } from '../../../../helpers'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'

const SidebarMenuMain = () => {
  const intl = useIntl()

  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='element-11'
        title={`Search`}
        fontIcon='bi-app-indicator'
      />
      {/* <SidebarMenuItem
        to='#'
        icon='element-11'
        title={`VAMPP-noncoding`}
        disabled={true}
        fontIcon='bi-app-indicator'
      />
      <SidebarMenuItem
        to='#'
        icon='element-11'
        title={`VAMPP-somatic`}
        disabled={true}
        fontIcon='bi-app-indicator'
      /> */}
      

      {/* <SidebarMenuItemWithSub
        to='/crafted/pages'
        title='Search'
        fontIcon='bi-search'
        icon='element-10'
      >
        <SidebarMenuItem
          to='search-gene'
          title='Gene'
          hasBullet={true}
          fontIcon='bi-layers'
        />
        <SidebarMenuItem
          to='search-variant'
          title='Variant'
          fontIcon='bi-layers'
          hasBullet={true}
        />
        <SidebarMenuItem
          to='#'
          title='Somatic'
          disabled={true}
          fontIcon='bi-layers'
          hasBullet={true}
        />
      </SidebarMenuItemWithSub> */}

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Static</span>
        </div>
      </div>

      {/* <SidebarMenuItem
        to='#'
        icon='abstract-28'
        title='Documentations'
        fontIcon='bi-layers'
      /> */}
      <SidebarMenuItem
        to='/publications'
        icon='receipt-square'
        title='Publications'
        fontIcon='bi-layers'
      />
      <SidebarMenuItem
        to='/about'
        icon='question'
        title='About'
        fontIcon='bi-layers'
      />
      <SidebarMenuItem
        to='/help'
        icon='book-square'
        title='Help'
        fontIcon='bi-layers'
      />
      <SidebarMenuItem
        to='#'
        icon='data'
        title='Download'
        fontIcon='bi-layers'
      />
      <SidebarMenuItem
        to='/version-history'
        icon='code'
        title='Version History'
        fontIcon='bi-layers'
      />

    </>
  )
}

export { SidebarMenuMain }
